import { queryOptions, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../../api";
import type { ActiveUser } from "../../../UserManagement/UserManagement.types";
import { expressOnboardingApi } from "../../api/expressOnboardingApi";
import type { ExpressOnboardingGenerator } from "../../ExpressOnboarding.types";

export const expressOnboardingGeneratorsQueries = {
  list: (userId: ActiveUser["id"] | null) =>
    queryOptions({
      queryKey: expressOnboardingApi.generators.key(userId),
      queryFn: () => fetchExpressOnboardingGenerators(userId),
      staleTime: 1000 * 60 * 1 // 1 minute
    })
};

function useExpressOnboardingGenerators(userId: ActiveUser["id"] | null) {
  return useQuery(expressOnboardingGeneratorsQueries.list(userId));
}

async function fetchExpressOnboardingGenerators(
  userId: ActiveUser["id"] | null
) {
  const response = await apiWithoutCamelization.get<
    Array<ExpressOnboardingGenerator>
  >(expressOnboardingApi.generators.url(userId));
  return response.data;
}

export default useExpressOnboardingGenerators;
